'use strict';
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        deleted: false,
        size: '',
        type: ''
    },

    isDeleted: function() {
        return this.get('deleted');
    },

    getContentSize: function() {
        return this.get('size');
    },

    getContentType: function() {
        return this.get('type');
    },

    isImage: function() {
        return this.getContentType().indexOf('image/') == 0;
    },

    isXLS: function() {
        return this.getContentType() == 'application/vnd.ms-excel';
    },

    isXMI: function() {
        return this.getContentType() == 'application/vnd.xmi+xml';
    },

    isPDF: function() {
        return this.getContentType() == 'application/pdf';
    }
});



// WEBPACK FOOTER //
// ./data/domain/value/content/meta-data.js